import React from 'react';
import { RoutesCard } from './RoutesCard';
import styles from './RoutesSection.module.sass';

export const RoutesSection = (props) => {
  return (
    <section
      className={styles.RoutesSection}
      id={`lp${props?.index}-${encodeURI(props?.title)}`}
      data-testid="RoutesSection"
    >
      <hr />
      <div className={styles.RoutesSectionContent}>
        <div className={styles.RoutesSectionDescription}>
          <div>
            <h2>{props?.title}</h2>
            <p>{props?.description}</p>
          </div>
        </div>
        <div className={styles.RoutesSectionCards}>
          <div>
            {props?.routes?.map((item, index: number) => (
              <RoutesCard key={`routeCard-${index}`} progress={props?.routesProgress?.[item?.id]} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
